import { z } from "zod";
export const tableStorageEntrySchema = z.object({
    tableName: z.string(),
    category: z.enum([
        "transactions_processed",
        "transactions_archival",
        "side_effects",
        "analysis_output",
        "metadata",
    ]),
    dataBytes: z.number(),
    indexBytes: z.number(),
    totalBytes: z.number(),
});
export const archivalBreakdownSchema = z.object({
    rawTxBytes: z.number().nullable(),
    rawTxEffectBytes: z.number().nullable(),
    publicCallsBytes: z.number().nullable(),
    l2ToL1MsgDetailsBytes: z.number().nullable(),
});
export const storageOverviewSchema = z.object({
    tables: z.array(tableStorageEntrySchema),
    archivalBreakdown: archivalBreakdownSchema,
    totalBytes: z.number(),
    generatedAt: z.string(),
});
//# sourceMappingURL=admin.js.map